
import HeroSection from './components/HeroSection';
import SecuritySolutions from './components/SecuritySolutions';
import CybersecurityServices from './components/CybersecurityServices';
import FirewallSecurity from './components/FirewallSecurity';
import EndpointProtection from './components/EndpointProtection';
import IdentityManagement from './components/IdentityManagement';
import DataBackup from './components/DataBackup';
import SecurityAudits from './components/SecurityAudits';
import ParallaxBackground from './components/ParallaxBackground';

export default function Home() {
  return (
    <div className="relative min-h-screen overflow-x-hidden">
      <ParallaxBackground />
      <div className="relative z-10">
        <HeroSection />
        <SecuritySolutions />
        <CybersecurityServices />
        <FirewallSecurity />
        <EndpointProtection />
        <IdentityManagement />
        <DataBackup />
        <SecurityAudits />
      </div>
    </div>
  );
}
